import { useEffect } from "react";

const DEFAULTS = {
  siteName: "My Animation",
  url: "https://myanimation.fr",
  ogImage: "https://myanimation.fr/og-image.jpg",
  locale: "fr_FR",
};

function upsertMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, prop] = selector.match(/\[(.+?)=/) || [];
    if (prop === "name") el.setAttribute("name", attr);
    else if (prop === "property") el.setAttribute("property", attr);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, path = "", keywords, image, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', "description", description);
      upsertMeta('meta[property="og:description"]', "og:description", description);
      upsertMeta('meta[name="twitter:description"]', "twitter:description", description);
    }
    if (title) {
      upsertMeta('meta[property="og:title"]', "og:title", title);
      upsertMeta('meta[name="twitter:title"]', "twitter:title", title);
    }
    if (keywords) {
      upsertMeta('meta[name="keywords"]', "keywords", keywords);
    }
    const ogImg = image || DEFAULTS.ogImage;
    upsertMeta('meta[property="og:image"]', "og:image", ogImg);
    upsertMeta('meta[name="twitter:image"]', "twitter:image", ogImg);
    upsertMeta('meta[name="twitter:card"]', "twitter:card", "summary_large_image");
    upsertLink("canonical", `${DEFAULTS.url}${path}`);
    upsertMeta('meta[property="og:url"]', "og:url", `${DEFAULTS.url}${path}`);
    upsertMeta('meta[property="og:type"]', "og:type", "website");
    upsertMeta('meta[property="og:locale"]', "og:locale", DEFAULTS.locale);
    upsertMeta('meta[property="og:site_name"]', "og:site_name", DEFAULTS.siteName);
    upsertMeta('meta[name="robots"]', "robots", noindex ? "noindex, follow" : "index, follow");
  }, [title, description, path, keywords, image, noindex]);
}

export function JsonLd({ data, id }) {
  useEffect(() => {
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node && !id) node.remove(); // keep persistent if id provided externally
    };
  }, [data, id]);
  return null;
}
